export const SET_GLOBAL_SUCCESS = "SET_GLOBAL_SUCCESS";
export const SET_GLOBAL_ERROR = "SET_GLOBAL_ERROR";
export const SET_GLOBAL_SUCCESS_MESSAGE = "SET_GLOBAL_SUCCESS_MESSAGE";
export const SET_GLOBAL_ERROR_MESSAGE = "SET_GLOBAL_ERROR_MESSAGE";
export const SET_GLOBAL_LOADING = "SET_GLOBAL_LOADING";
export const SET_CANCEL_CONFIRMATION_DIALOG = "SET_CANCEL_CONFIRMATION_DIALOG";
